import React from 'react';
import { Students } from '../../../../../../models/StudentsModel/students.model';
import StudentService from '../../../../../../services/InstituteService/student.service';
import PasswordUpdateDrawer from '../../../../../../shared/components/PasswordUpdateDrawer';

interface StudentPasswordFormProps {
  open: boolean;
  onClose: () => void;
  setOpen: Function;
  studentData: Students;
  isPrivate?: boolean;
}

export const StudentPasswordForm: React.FC<StudentPasswordFormProps> = ({ open, onClose, studentData, setOpen, isPrivate }) => {

  const updatePassword = (values: { password: string; confirmPassword: string }) => {
    if (isPrivate) {
      StudentService.updatePrivateStudentPassword(
        studentData.id,
        values.password,
        () => setOpen(false)
      );
    } else {
      StudentService.updatePassword(
        studentData.id,
        values.password,
        () => setOpen(false)
      );
    }
    
  };

  return (
    <PasswordUpdateDrawer
      open={open}
      onClose={onClose}
      onSubmit={updatePassword}
    />
  );
};
